<div>
  <ng-container host-view-container></ng-container>
</div>
